<template xmlns="http://www.w3.org/1999/html">
    <div class="bundle-items container">
      <loading :active.sync="isLoading"
               :can-cancel="false"
               :is-full-page="true">
      </loading>
      <div v-for="item in this.bundle" :key="item.id">
        <div class="row">
          <div class="col-12">
            <dropdown-element
                :title="item.name"
                :options="item.attach"
                session_key="select_set_attach"
                :id="item.id"
                :image="item.image"
            ></dropdown-element>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div v-for="attach in item.attach" >
              <div v-if="attach.selected==true && (typeof attach.items !== 'undefined')">
                <dropdown-element
                    :title="item.message"
                    :options="ObjToArray(attach.items)"
                    session_key="select_set_attach_items"
                    :id="attach.id"
                    :image="attach.image"
                ></dropdown-element>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="isBundleReady" class="bundle-itogo">
        <div class="title">Состав комплекта:</div>

        <div class="row tbl" v-for="item in this.selectedItems">
          <div class="col-2 p-1">
            <a title="посмотреть информацию о товаре в новом окне" :href="item.link" target="_blank"><img class="img-fluid" :src="item.image" /></a>
          </div>
          <div class="col-4 my-auto">
            <div>{{ item.set_name }}</div>
            <div>
              <a title="посмотреть информацию о товаре в новом окне" :href="item.link" target="_blank">{{ item.article }}</a>
              {{ item.name }}
            </div>
          </div>

          <div class="col-2 my-auto">
            {{ item.count }}шт.
          </div>
          <div class="col-2 my-auto">
            {{ formatPrice(item.cost) }}
          </div>
          <div class="col-2 my-auto">
            <a v-on:click="removeItem(item)" href="#">
              <svg v-show="item.id != item.bundle_id" class="cart__item-remove-icon" width="15" height="15">
                <use xlink:href="#icon-cross"></use>
              </svg></a>
          </div>
        </div>

        <div class="row tbl py-2">
          <div class="col-8">Итого:</div>
          <div class="col-4">
            <span :class="[this.selectedSumm.summ_discount < this.selectedSumm.summ ? 'cart__item-old-price':'']">{{ formatPrice(this.selectedSumm.summ) }}</span>
          </div>
        </div>
        <div class="row tbl py-2">
          <div class="col-8">Скидка:</div>
          <div class="col-4">
            {{ this.selectedSumm.discount}}%
          </div>
        </div>
        <div class="row tbl py-2 itogo">
          <div class="col-8">Итого со скидкой:</div>
          <div class="col-4">
            {{ formatPrice(this.selectedSumm.summ_discount) }}
          </div>
        </div>

        <cart-add-button-bundle
                title=""
                css_class="btn btn--red p-buy__buy-btn mt-2"
                init_text="Купить комплект"
                :product_id="this.localProductId"
                :base_url="this.localBaseUrl"
        ></cart-add-button-bundle>
      </div>
    </div>

</template>

<script>
    import DropdownElement from './dropdown-element'
    import CartAddButtonBundle from './cart-add-button-bundle'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: "product-bundle",
        components: {
          DropdownElement,
          CartAddButtonBundle,
          Loading
        },
        props: [
            'product_id',
            'base_url'
        ],
        data() {
          return {
            localProductId: this.product_id,
            localBaseUrl: this.base_url
          };
        },
        computed: {
          bundle: function () {
            let bundle = this.$store.getters.bundle;

            /*if(bundle !== null) {
              console.log(bundle)
              bundle.attach.items = Object.entries(bundle.attach.items).map((e) => ({[e[0]]: e[1]}));
              console.log(bundle.attach.items)
            }*/

            return bundle;
          },
          selectedItems: function () {
            return this.$store.getters.selectedBundleItems
          },
          selectedSumm: function () {
            return this.$store.getters.selectedBundleItemsSumm
          },
          isLoading: function () {
            return this.$store.getters.loading
          },
          isBundleReady: function () {

            let scope = this;
            let items = this.$store.getters.selectedBundleItems;
            if(!items) {
              return false
            }
            let item = items.filter(function (elem) {
              return elem.product_id != scope.localProductId
            })

            if(typeof item[0] !== 'undefined') {
              return true;
            }
            return false;
          }
        },
        methods: {
          async loadBundle() {
            await this.$store.dispatch('getBundle')
          },
          formatPrice(price) {
            // Create our number formatter.
            var formatter = new Intl.NumberFormat('ru-RU', {
              style: 'currency',
              currency: 'RUB',

              // These options are needed to round to whole numbers if that's what you want.
              //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
              maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
            });

            return formatter.format(price); /* $2,500.00 */
          },
          removeItem(item) {
            Evnt.fire('ResetDropdown', item.session_key)
          },
          ObjToArray(items) {
            if(!Array.isArray(items)) {
              return Object.keys(items).map(i => items[i]);
            }
            return items;
          }
        },
        mounted() {
          this.$store.commit('SET_BUNDLE_ID', this.localProductId)
          this.loadBundle()
        }
    }
</script>

<style scoped>
  .title {
    font-size: 12px;
    font-weight: bold;
    padding-top: 10px;
    text-transform: uppercase;
  }
  .itogo div {
    font-weight: bold;
  }
  .v {
    vertical-align: middle;
  }
  .tbl {
    border-top: 1px solid #dee2e6;
  }
  .bundle-itogo {
    overflow-x: hidden
  }
</style>
